<template src="./index.html"></template>
<script>
import { loginv2, verifyCode, getRoleMenuIdListByUser, familyLogin, updateUserPwd, getPwdVerify } from '../../../api/home.js';
import { hex_md5 } from '../../../../md5.js';
import configHttp from '../../../../configHttp.js';
import configHttpProduct from '../../../../configHttpProduct.js';
export default {
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.enterText.resetpassword !== '') {
					this.$refs.enterText.validateField('resetpassword');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.enterText.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			showpassword: false,
			loginform: {
				phone: '',
				email: '',
				password: '',
				sign: '',
				type: 1
			},
			picture: '',
			loginformrules: {
				phone: [
					{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}
				],
				password: [
					{
						required: true,
						message: '密码未填写，请填写完整',
						trigger: 'blur'
					}
				],
				sign: [
					{
						required: true,
						message: '验证码未填写，请填写完整',
						trigger: 'blur'
					}
				]
			},
			uuid: '',
			subject: false,
			title: '修改密码',
			enterText: {
				password: '',
				resetpassword: '',
			},
			rules: {
				password: [{ required: true, validator: validatePass, trigger: 'blur' }],
				resetpassword: [{ required: true, validator: validatePass2, trigger: 'blur' }]
			},
			userPwdVerify: {}
		};
	},
	created() {
		//产品单点登录
		if (configHttpProduct.portalSwitch) {
			let requestParam = this.getRequestParam();
			let portalLogin = localStorage.getItem('portalLogin');
			let token = requestParam['token'];
			let localToken = localStorage.getItem('token');
			if (token == null) {
				token = localToken;
			}
			if ((requestParam && requestParam['token']) || portalLogin == 'true') {
				this.$router.push('/login_Product');
			} else {
				localStorage.setItem('portalLogin', 'false');
				this.verification();
			}
		} else {
			if (this.projectType == 'Amat' && this.ssoSwitch) {
				this.$router.push('/login_Fin');
			} else {
				this.verification();
			}
		}
		if (this.projectType != 'Amat'){
			getPwdVerify().then(res => {
				this.userPwdVerify = res.data.data;
			});
		}
	},
	mounted() {
		var _self = this;
		document.onkeydown = function(e) {
			var key = window.event.keyCode;
			if (key == 13) {
				_self.forlogin(); // 登录的方法
			}
		};
	},
	methods: {
		verification() {
			verifyCode().then(res => {
				if (res.data.code == '200') {
					this.picture = res.data.data.img;
					this.uuid = res.data.data.uuid;
					this.$forceUpdate();
				}
			});
		},
		editPwd() {
			this.$refs.enterText.validate(valid => {
				if (valid) {
					let params = {
						userName: this.loginform.phone,
						oldPassword: hex_md5(this.loginform.password),
						newPassword: hex_md5(this.enterText.password)
					};
					let password = this.enterText.password;
					if(configHttp.projectType !='Amat'){
						const regex = new RegExp(this.userPwdVerify.regex);
						if (!regex.test(password) || password.length < this.userPwdVerify.minlen) {
							this.$message.error(this.userPwdVerify.regexText);
							return;
						}
					}
					updateUserPwd(params).then(res2 => {
						if (res2.data.data) {
							this.$message.success(res2.data.message);
							this.subject = false;
							this.loginform.password = "";
							this.loginform.sign = "";
							this.verification();
						} else{
							this.$message.error(res2.data.message);
						}
					});
				} else {
					return false;
				}
			});
		},
		forlogin() {
			this.$refs['loginform'].validate(async valid => {
				if (valid) {
					let params = {
						userName: this.loginform.phone,
						password: hex_md5(this.loginform.password),
						code: this.loginform.sign,
						uuid: this.uuid
					};
					loginv2(params).then(res => {
						if (res.data.data.success) {
							localStorage.setItem('currentLoginUser', JSON.stringify(res.data.data.currentLoginUser));
							localStorage.setItem('sysUserSTXX', JSON.stringify(res.data.data.sysUserSTXX));
							localStorage.setItem('token', res.data.data.token);
							getRoleMenuIdListByUser().then(res1 => {
								res1.data.data.menuList.unshift({
									children: [],
									icon: 'meauicon5',
									id: '2',
									resCode: 'home',
									resName: '首页',
									checked: false
								});
								localStorage.setItem('MenuPermission', JSON.stringify(res1.data.data.menuList));
								localStorage.setItem('resources', JSON.stringify(res1.data.data.buttonList));
								var meaurouter = [];
								digui(res1.data.data.menuList);
								function digui(data) {
									data.forEach(v => {
										if (v.children) {
											if (v.resCode != '' && v.resName != '凭证导入' && v.resName != '账务查询' && v.resName != '报表中心') {
												meaurouter.push(v.resCode);
											}
											digui(v.children);
										} else {
											if (v.resCode == 'VoucherQuery') {
												meaurouter.push('VoucherDetail');
												meaurouter.push('PreviewVoucher');
												meaurouter.push('GLView');
												meaurouter.push('SubLedgerTable');
											}
											meaurouter.push(v.resCode);
										}
									});
								}
								localStorage.setItem('meaurouter', meaurouter);
								this.$router.push({
									path: '/' + meaurouter[0]
								});
							});
						} else {
							if(res.data.data.msgType == "4") {
								// 密码过期，强制修改密码
								this.subject = true;
								this.enterText.password = "";
								this.enterText.resetpassword = "";
							} else{
								this.$message.error(res.data.data.message);
							}
						}
					});
				}
			});
		},
		getRequestParam() {
			//  获取请求后面的参数
			var requestParam = new Object();
			if (location.href.indexOf('?') != -1) {
				var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
				var str = url.substr(1);
				let strs = str.split('&');
				for (var i = 0; i < strs.length; i++) {
					requestParam[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
				}
			}
			return requestParam;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
